import { DashboardKomisiScreen } from "@/screens";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  programManagerId: z.string().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
});

export const Route = createFileRoute("/dashboard/komisi")({ 
  component: DashboardKomisiScreen,
  validateSearch: searchSchema,
  loader: () => ({
    crumb: "Dashboard Komisi",
  }),
});